<template>
  <div id="app">
    <Header routeValue="3"></Header>
    <content class="content-details">
      <div class="ad_banner" v-if="images.length > 0">
        <a-carousel arrows autoplay>
          <div
            slot="prevArrow"
            slot-scope="props"
            class="custom-arrow"
            style="left: 10px;zIndex: 1"
          >
            <img src="../assets/icon_left_2.png"/>
          </div>
          <div slot="nextArrow" slot-scope="props" class="custom-arrow" style="right: 10px">
            <img src="../assets/icon_right_2.png"/>
          </div>
          <div v-for="(image,i) in images" :key="i" @click="onClick(image)">
            <img :src="image|imgFilter()" alt="img" class="carousel-image">
          </div>
        </a-carousel>
      </div>
      <div class="content_info">
        <div class="label" v-if="selectNames.length>0">
          <div v-for="(item, index) in selectNames" :key="index">
            <a @click="toProducts(item.id)"
               :class="{ 'last-item': selectNames.length > 1 && index === selectNames.length - 1 }">
              {{ item.name }}
            </a>
            <span v-if="index !== selectNames.length - 1" style="margin: 0 5px">/</span>
          </div>
        </div>
        <div class="banner_box">
          <div class="swiper_box">
            <div class="dots_prev_button" @click="goToSlidePrev()">
              <a-icon type="left" style="font-size: 16px"/>
            </div>
            <div class="dots_next_button" @click="goToSlideNext()">
              <a-icon type="right" style="font-size: 16px"/>
            </div>
            <!-- swiper Thumbs -->
            <a-carousel arrows dots-class="slick-dots slick-thumb" ref="carousel" effect="fade" :beforeChange="onCarouselBeforeChange">
              <a slot="customPaging" slot-scope="props">
                <img :src="skuDesInfo.atlas[props.i].img | imgFilter(88)"/>
              </a>
              <div slot="prevArrow" id="prevArrow" slot-scope="props" class="slick_arrow" style="left: 8px"
                   @mouseover="hideArrows">
                <img src="../assets/icon_left.png"/>
              </div>
              <div slot="nextArrow" id="nextArrow" slot-scope="props" class="slick_arrow" style="right: 50px"
                   @mouseover="hideArrows">
                <img src="../assets/icon_right.png"/>
              </div>
              <div v-for="item in skuDesInfo.atlas">
                <div class="img_box" @mouseover="hideArrows" @mouseleave="showArrows">
                  <img :src="item.img | imgFilter(570)" alt="image"/>
                  <div class="product-operate">
                    <div :class="'collection ' + (collectIds.indexOf(skuDesInfo.id) > -1 ? 'collected':'') "
                         @click.stop="collect(skuDesInfo.id)"></div>
                  </div>
                </div>
              </div>
            </a-carousel>
          </div>
          <div class="banner_info">
            <span class="title"
                  :title="skuDesInfo.productNameEn || 'N/A' ">{{ skuDesInfo.productNameEn || 'N/A' }}</span>

            <div class="deliver_box">
              <div class="text">Deliver to</div>
              <img :src="getCountryIcon(currentCountry)" alt="" class="country-icon"/>
              <a-dropdown class="country-dropdown">
                <a class="dropdown-link" @click.prevent>
                  {{ countryData[currentCountry] && countryData[currentCountry].name || 'N/A' }}
                  <img src="../assets/icon/caret-down.png" class="dropdown-icon"/>
                </a>
                <a-menu slot="overlay" style="overflow-y: auto;max-height: 460px">
                  <a-menu-item
                    v-for="(item, index) in menuItems"
                    :key="index"
                    style="margin: 8px; border-radius: 3px"
                    :class="{ 'menu-item-selected': currentCountry === item.divisionValue }"
                  >
                    <div class="menu-item" @click="selectCountry(item.divisionValue)">
                      <div class="menu-icon">
                        <img :src="getCountryIcon(item.divisionValue)" class="country-icon"/>
                      </div>
                      <span class="menu-name">{{ item.divisionName || 'N/A' }}</span>
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
            <div class="price_view">
              <span class="price" v-if="false">Price ：<span style="color: #012169">
                {{ skuDesInfo.priceDescription }}</span>
              </span>
              <div class="price_box">
                <div class="item" v-for="item in matchObj.divisionVipPrice" v-if="Object.keys(item).length !== 0">
                <span class="item_price">
                  <span v-if="item.price">USD {{ item.price }}</span>
                  <span v-else>N/A</span>
                </span>
                  <span class="item_rank">
                  <img src="../assets/icon/bronze.png" style="margin-top: -2px" v-if="item.level===0"/>
                  <img src="../assets/icon/platinum.png" style="margin-top: -2px" v-else-if="item.level===1"/>
                  <img src="../assets/icon/diamond.png" style="margin-top: -2px" v-else/>
                  {{ item.level === 0 ? 'Bronze' : item.level === 1 ? 'Platinum' : 'Diamond' }}
                </span>
                </div>
              </div>
              <div class="deliver_des" v-if="countryData[currentCountry]&&countryData[currentCountry].text">
                {{ countryData[currentCountry].text }}
              </div>
            </div>
            <div class="price_box" style="margin-top: 40px">
              <div class="item">
                <span class="item_time">
                  Production time
                  <a-tooltip :overlayStyle="{'max-width':'360px'}">
                    <template slot="title">
                      <div>Refers to calendar days (including weekends).</div>
                      <div>Excludes force majeure events (e.g., natural disasters).</div>
                    </template>
                    <img class="info-icon info-icon-days" src="../assets/info.png"/>
                  </a-tooltip>
                </span>
                <span class="item_day">
                  {{ skuDesInfo.performanceTime || 0 }}-{{ skuDesInfo.performanceTimeEnd || 0 }}<span
                  class="item_day-days">
                    <span class="item_day-days-text">days</span>
                  </span>
                </span>
              </div>
              <div class="item">
               <span class="item_time">
                  SPU
                </span>
                <span class="item_day">
                  <a-tooltip
                    placement="right"
                    overlayClassName="spu-tooltip-overlay"
                    :overlayStyle="{ maxWidth: '360px' }">
                    <template slot="title">
                      <div class="spu-tooltip-content">
                        <div class="spu-tooltip-label">Product code:</div>
                        <div v-for="item in skuDesInfo.skuViewVOS" :key="item.sn" class="spu-tooltip-item">
                          {{ item.sn }}
                        </div>
                      </div>
                    </template>
                  {{ skuDesInfo.productCode }}
                  </a-tooltip>
                </span>
              </div>
              <div class="item" style="display: flex" v-if="skuDesInfo.youtubeUrl">
                <span class="item_time">
                  Product Video
                </span>
                <span class="item_day" @click="handleVideo(skuDesInfo.youtubeUrl)">
                  <img src="../assets/video.png" style="width: 32px;height: 26px;margin-left: 40px;cursor: pointer"/>
                </span>
              </div>
            </div>
            <div class="spec_box" ref="designsBox">
              <div>
                <div v-for="(productItem, productIndex) in specifications">
                  <div class="subhead">{{ productItem.name }}</div>
                  <div class="spec_list">
                    <div v-for="(oItem, oIndex) in productItem.item" :key="oItem.name">
                      <!-- imgUrl > colorValue > optionName；第一级始终展示，其余级按可用性隐藏 -->
                      <a-tooltip v-if="oItem.imgUrl && (productIndex === 0 || oItem.checked)" :title="oItem.name">
                        <div
                          class="spec_item_img"
                          :class="{
                            activeImg: subIndex[productIndex] === oIndex
                          }"
                          @click="selectArrayBtn(oItem, productIndex, oIndex)">
                          <div class="spec_item_img_inner">
                            <img :src="oItem.imgUrl | imgFilter(110)" :alt="oItem.name"/>
                          </div>
                        </div>
                      </a-tooltip>
                      <a-tooltip v-else-if="oItem.colorValue && (productIndex === 0 || oItem.checked)" :title="oItem.name">
                        <div
                          class="spec_item_color"
                          :class="{
                            activeColor: subIndex[productIndex] === oIndex
                          }"
                          @click="selectArrayBtn(oItem, productIndex, oIndex)">
                          <div class="spec_item_color_inner" :style="{ background: oItem.colorValue }"></div>
                        </div>
                      </a-tooltip>
                      <div v-else-if="productIndex === 0 || oItem.checked"
                           :class="{ active: subIndex[productIndex] === oIndex }"
                           @click="selectArrayBtn(oItem, productIndex, oIndex)" class="spec_item">
                        {{ oItem.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="paused_notice" v-if="String(skuDesInfo.status) === '2'">
              <img src="../assets/icon/remind.png" class="paused_notice_icon" alt=""/>
              <div class="paused_notice_text">
                <span class="paused_notice_label">Product Notice:</span> This item is currently inactive.<br/>
                Accounts with <span class="paused_notice_highlight">50+ daily orders</span> can request priority
                reactivation. Alternatively, explore our higher-converting similar products to boost your sales!
              </div>
            </div>
            <div class="btn_box">
              <template v-if="String(skuDesInfo.status) === '2'">
                <div class="btn1 paused">Paused</div>
              </template>
              <template v-else>
                <a-tooltip placement="topLeft" :overlayStyle="{'color': 'rgba(0, 0, 0, 1)','max-width':'1500px'}"
                           v-if="!skuDesInfo.hasDesignTemplate">
                  <template slot="title">
                    <div
                      style="font-family: HarmonyOS Sans SC;font-weight: 400;font-size: 14px;color: #FFFFFF;line-height: 18px;margin:1px 2px;">
                      The mockup isn't ready yet.
                      <br>
                      Contact support if you need to use it urgently.
                    </div>
                  </template>
                  <div :class="'btn1 ' + (skuDesInfo.hasDesignTemplate ? '' : 'disabled')" @click="toCreateTemplate">
                    Start designing
                  </div>
                </a-tooltip>
                <div v-if="skuDesInfo.hasDesignTemplate"
                     :class="'btn1 ' + (skuDesInfo.hasDesignTemplate ? '' : 'disabled')" @click="toCreateTemplate">
                  Start designing
                </div>
              </template>

              <div class="btn" @click="toContactSupport">Contact support</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tabs_box">
        <a-tabs default-active-key="Description" @change="callback" :animated="false">
          <a-tab-pane key="Description" tab="Description">
            <div>
              <iframe
                ref="myIframe"
                :srcdoc="skuDesInfo.desc"
                @load="adjustIframeSize"
                scrolling='no'
                style="border: none; width: 100%">
              </iframe>
            </div>
          </a-tab-pane>
          <a-tab-pane key="Pricing" tab="Pricing">
            <div class="spec_des_box">
              <table class="table_spec">
                <thead class="ant-table-thead">
                <tr>
                  <th v-for="(spec,i) in skuDesInfo.skuVOList[0].specOptionVOS">
                    {{ spec.specsName }}
                  </th>
                  <th>Product code</th>
                  <th class="th_price">
                    <!-- 新增 flex 容器包裹图片和文字 -->
                    <div class="vip-level-container">
                      <img src="../assets/icon/bronze1.png" v-if="vipLevel === 0" class="vip-icon"/>
                      <img src="../assets/icon/platinum1.png" v-else-if="vipLevel === 1" class="vip-icon"/>
                      <img src="../assets/icon/diamond1.png" v-else class="vip-icon"/>
                      <span class="vip-text">{{
                          vipLevel === 0 ? 'Bronze' : vipLevel === 1 ? 'Platinum' : 'Diamond'
                        }}</span>
                    </div>
                  </th>
                  <th></th>

                  <!-- Platinum 等级列 -->
                  <th class="th_price1">
                    <div class="vip-level-container">
                      <img src="../assets/icon/platinum1.png" class="vip-icon"/>
                      <span class="vip-text">Platinum</span>
                    </div>
                  </th>
                  <th></th>

                  <!-- Diamond 等级列 -->
                  <th class="th_price2">
                    <div class="vip-level-container">
                      <img src="../assets/icon/diamond1.png" class="vip-icon"/>
                      <span class="vip-text">Diamond</span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody class="ant-table-tbody">
                <tr v-for="(item,i) in skuDesInfo.skuVOList" :key="i" class="ant-table-row">
                  <td v-for="(spec,i) in item.specOptionVOS">
                    {{ spec.optionName }}
                  </td>
                  <td>
                    {{ item.sn }}
                  </td>
                  <td v-for="(vip, index) in item.vipPrice"
                      :key="index"
                      :style="getBorderStyle(vip.level, i,skuDesInfo.skuVOList)"
                      :class="[{'td_price': vip.level === 0,'td_price1': vip.level === 1, 'td_price2': vip.level === 2}]">
                    {{ Object.keys(vip).length !== 0 ? ' $' + vip.price : '' }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="Shipping" tab="Shipping">
            <div class="logistics_box">
              <div class="table_box">
                <div class="item" v-for="item in logisticsList" :class="{ active: item.checked}"
                     @click="tableChange(item)">
                  <div class="shipping">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <a-table
                class="table_spec"
                rowKey="key"
                :locale="tableLocale"
                :columns="columns"
                :data-source="stateList"
                :pagination="false">

                <span slot="shippingTimeTitle">
                  Shipping time
                  <a-tooltip :overlayStyle="{'max-width':'360px'}">
                    <template slot="title">
                      <div>Refers to calendar days (including weekends).</div>
                      <div>Excludes force majeure events (e.g., natural disasters).</div>
                    </template>
                    <img class="info-icon" src="../assets/info.png"/>
                  </a-tooltip>
                </span>
                <span slot="shippingTime" slot-scope="text">
                  {{ text }}
                </span>
                <span slot="totalCostTitle">
                   Total cost
                   <a-tooltip title="From 2nd item and up, huge savings! Log in for details."
                              :overlayStyle="{'max-width':'360px'}">
                     <img class="info-icon" src="../assets/info.png"/>
                   </a-tooltip>
                 </span>
                <span slot="baseCostTitle">
                  Base cost
                  <a-tooltip title="From 2nd item and up, huge savings! Log in for details."
                             :overlayStyle="{'max-width':'360px'}">
                    <img class="info-icon" src="../assets/info.png"/>
                  </a-tooltip>
                 </span>
                <span slot="divisionName" slot-scope="text, record, index">
                  {{ record.divisionName }}
                  <img
                    class="info-icon"
                    src="../assets/info.png"
                    v-if="index > 2 && record.sn === 'ALL' && isShowInfo.includes(record.divisionValue)"
                    @click.stop="showZoneCountriesModal(record)"
                  />
                </span>
                <span slot="price" slot-scope="text, record">
                    {{ record.price !== null && typeof record.price === 'number' ? '$' + record.price : record.price }}
                </span>
                <span slot="tariff" slot-scope="text, record">
                  {{
                    record.tariffPrice !== null && typeof record.tariffPrice === 'number' ? '$' + record.tariffPrice : record.tariffPrice
                  }}
                </span>
                <span slot="OptFees" slot-scope="text, record">
                  {{
                    record.optFee !== null && typeof record.optFee === 'number' ? '$' + record.optFee : record.optFee
                  }}
                </span>
                <span slot="extraPrice" slot-scope="text, record">
                    {{
                    record.extraPrice !== null && typeof record.extraPrice === 'number' ? '$' + record.extraPrice : record.extraPrice
                  }}
                </span>
                <span slot="totalCost" slot-scope="text, record">
                  <template v-if="record.totalCostMin === 'N/A' || record.totalCostMax === 'N/A'">
                    N/A
                  </template>
                  <template v-else-if="record.totalCostMin || record.totalCostMax">
                    <span v-if="record.totalCostMin">${{ record.totalCostMin }}</span>
                    <span v-if="record.totalCostMin && record.totalCostMax">~</span>
                    <span v-if="record.totalCostMax">${{ record.totalCostMax }}</span>
                  </template>
                </span>
                <span slot="baseCost" slot-scope="text, record">
                  <template v-if="record.baseCostMin || record.baseCostMax">
                    <span v-if="record.baseCostMin">${{ record.baseCostMin }}</span>
                    <span v-if="record.baseCostMin && record.baseCostMax">~</span>
                    <span v-if="record.baseCostMax">${{ record.baseCostMax }}</span>
                  </template>
                </span>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="Guidelines" tab="File Guidelines">
            <div style="margin-bottom: 8px;font-family: HarmonyOS Sans SC">
              <a style="font-size: 17px" :href="skuDesInfo.artTemplateUrl" target="_blank">
                Download templates and mockups here
              </a>
              <div style="font-size: 17px;color: #333333;margin-bottom: 25px;font-weight: bold;line-height: 2;">Print
                Guidelines
              </div>
            </div>
            <div>
              <iframe
                ref="myIframe"
                :srcdoc="designSpecContent"
                @load="adjustIframeSize"
                scrolling='no'
                style="border: none; width: 100%;height: 0">
              </iframe>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="item_divider"></div>
      <div class="like_box">
        <div class="title">You might also like</div>
        <a-carousel arrows :dots="false" autoplay :autoplay-speed="8000" style="cursor: pointer;">
          <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: -50px;z-index: 1">
            <img src="../assets/icon/arrow_left.png"/>
          </div>
          <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: -50px;z-index: 1">
            <img src="../assets/icon/arrow_right.png"/>
          </div>
          <div v-for="(obj,key) in recommendList" :key="key">
            <div v-for="(obj2,key) in obj.imgs" :key="key" class="hotBox" @click="handleSelectRecommend(obj2)">
              <div class="slide_box">
                <div class="img_box">
                  <img
                    class="img1" :src="obj2.productImg|imgFilter(318)">
                  <img
                    class="img2" :src="obj2.productTemplateImg|imgFilter(318)">
                </div>
                <span class="name">{{ obj2.productNameEn }}</span>
                <span class="size">{{ obj2.spec }}</span>
                <span class="size">
                      Production time {{ obj2.performanceTime }}-{{ obj2.performanceTimeEnd }}days
                </span>
                <span class="price">From USD {{ obj2.minPrice }}</span>
                <div class="tag_box" v-if="false">
                  <img src="../assets/best@2x.png" v-if="isShowTag(obj2,'Bestsellers')"
                       style="width: 74px;margin-right: 3px">
                  <img src="../assets/new@2x.png" v-if="isShowTag(obj2,'New')" style="width: 40px;margin-right: 3px">
                  <img src="../assets/trd@2x.png" v-if="isShowTag(obj2,'Trending')" style="width: 67px">
                </div>
                <div class="tag_box">
                  <span class="new" v-if="isShowTag(obj2,'New')">New</span>
                  <span class="best" v-if="isShowTag(obj2,'Bestsellers')">Bestseller</span>
                  <span class="trd" v-if="isShowTag(obj2,'Trending')">Trending</span>
                </div>
              </div>

            </div>
          </div>
        </a-carousel>
      </div>
    </content>
    <a-modal
      v-model="zoneCountriesVisible"
      :footer="null"
      :width="800"
      wrapClassName="zone-countries-modal"
    >
      <a-spin :spinning="zoneCountriesLoading">
        <div class="zone-countries-content">
          <div class="zone-section">
            <div class="zone-section-header">
              <img class="europe-icon" src="@/assets/Europe_icon.png" alt="Europe"/>
              <span><strong>Europe</strong> ( Tariff: {{ euZoneTariff }} )</span>
            </div>
            <div class="zone-section-body">{{ euZoneCountries }}</div>
          </div>
          <div class="zone-section">
            <div class="zone-section-header">
              <span><strong>Non-Europe</strong> ( Tariff: {{ nonEuZoneTariff }} )</span>
            </div>
            <div class="zone-section-body zone-section-body-scroll">{{ nonEuZoneCountries }}</div>
          </div>
        </div>
      </a-spin>
    </a-modal>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {get} from '@/api'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {getCartesianProduct, getSeoLinkName, isIdEmpty, setDataToSpecs, setDifferenceArray, uuid} from '@/utils/utils'

export default {
  name: 'Details',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    let that = this
    return {
      editorOption: {
        // 这里可以放置quill编辑器的配置
        readOnly: true // 设置为只读，仅展示，不可编辑
      },
      expandedRowKeys: [],
      images: [],
      searchType: 0,
      productId: undefined,
      productName: undefined,
      token: undefined,
      merchantId: undefined,
      slideNumber: 0,
      isOpen: false,
      zoneCountriesVisible: false,
      zoneCountriesLoading: false,
      euZoneCountries: '',
      nonEuZoneCountries: '',
      euZoneTariff: '$0',
      nonEuZoneTariff: '$0',
      euCountryCodes: null,
      isShowInfo: ['1Q', '2Q', '3Q', '4Q', '5Q', '6Q', '7Q', '7Q', '9Q'],
      selectedName: '',
      dynamicHeight: 0,
      specifications: [],
      //存放要和选中的值进行匹配的数据
      shopItemInfo: {},
      //存放被选中的值
      selectArr: [],
      //是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      subIndex: [],
      //最终匹配到的数据（id/名称）
      boxArr: {},
      // 初始默认 SKU（取消选中后用于恢复价格）
      defaultBoxArr: {},
      matchObj: {
        vipPrice: [],
        divisionVipPrice: [],
      },
      imgUrl: '',
      vipLevel: 0,
      skuDesInfo: {
        skuVOList: [
          {
            specOptionVOS: []
          }
        ]
      },
      collectIds: [],
      stateList: [],
      locationList: [],
      scrollPosition: 0,
      logisticsList: [
        {
          checked: true,
          key: 'STANDARD SHIPPING',
          name: 'Standard Shipping',
          skuVOList: [],
        },
        {
          checked: false,
          key: 'FAST SHIPPING',
          name: 'Express Shipping',
          skuVOList: [],
        },
        {
          checked: false,
          key: 'STANDARD SHIPPING(FAST)',
          name: 'Standard Shipping(FAST)',
          skuVOList: [],
        }
      ],
      tableLocale: {
        emptyText: 'Not Supported Yet',
      },
      columns: [
        {
          title: 'Shipping to',
          dataIndex: 'divisionName',
          scopedSlots: {customRender: 'divisionName'},
          width: '18%',
          align: 'left',
          customHeaderCell: (record, index) => {
            return {
              style: {
                paddingLeft: '40px'
              }
            }
          },
          customCell: (record, index) => {
            return {
              style: {
                paddingLeft: '40px'
              }
            }
          },
        },
        {
          title: 'Product code',
          dataIndex: 'sn',
          width: '14%',
          align: 'left',
          customCell: (record, index) => {
            return {
              style: {
                paddingRight: '10px'
              }
            }
          },
        },
        {
          dataIndex: 'shippingTime',
          scopedSlots: {customRender: 'shippingTime', title: 'shippingTimeTitle'},
          width: '12%',
          align: 'left',
        },
        {
          dataIndex: 'totalCostMin',
          scopedSlots: {customRender: 'totalCost', title: 'totalCostTitle'},
          width: '14%',
          align: 'left',
        },
        {
          dataIndex: 'baseCostMin',
          scopedSlots: {customRender: 'baseCost', title: 'baseCostTitle'},
          width: '14%',
          align: 'left',
        },
        {
          title: 'First item',
          dataIndex: 'price',
          scopedSlots: {customRender: 'price'},
          width: '10%',
          align: 'left',
        },
        {
          title: 'Additional',
          dataIndex: 'extraPrice',
          scopedSlots: {customRender: 'extraPrice'},
          width: '10%',
          align: 'left',
        },
        {
          title: 'Tariff',
          dataIndex: 'tariffPrice',
          scopedSlots: {customRender: 'tariff'},
          width: '10%',
          align: 'left',
        },
      ],
      designSpecContent: '',
      adBanner: '',
      recommendList: [],
      menuData: [],
      expandedMenu: new Map(),
      expandedMenuName: new Map(),
      selectNames: [],
      activeIdx: 0,
      swiperOptionTop: {
        spaceBetween: 10,
        effect: 'fade',
        loop: false,
        loopedSlides: 7,
        navigation: {
          prevEl: '.button-prev',
          nextEl: '.button-next',
        },
      },
      swiperOptionThumbs: {
        direction: 'vertical',
        centeredSlides: true,
        spaceBetween: 5,
        loop: false,
        observer: true,
        mousewheel: true,
        slidesPerView: 7,
        loopedSlides: 7,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
      },
      menuItems: [],
      resultObject: {},
      currentCountry: '',
      defaultCountryIcon: require('@/assets/state/DEFAULT.png'),
      countryData: {
        'US': {
          icon: require('@/assets/state/US.png'),
          name: '',
          text: 'Free shipping to United States. 2nd item and up, huge savings! Log in for details.'
        },
        'GB': {
          icon: require('@/assets/state/GB.png'),
          name: '',
          text: 'Free shipping to Unite Kingdom. 2nd item and up, huge savings! Log in for details.'
        },
        'AU': {
          icon: require('@/assets/state/AU.png'),
          name: '',
          text: 'Free shipping to Australia. 2nd item and up, huge savings! Log in for details.'
        },
        'CA': {
          icon: require('@/assets/state/CA.png'),
          name: '',
          text: 'Free shipping to Canada. 2nd item and up, huge savings! Log in for details.'
        },
        'DE': {
          icon: require('@/assets/state/DE.png'),
          name: '',
          text: 'Free shipping to Germany. 2nd item and up, huge savings! Log in for details.'
        },
        'FR': {
          icon: require('@/assets/state/FR.png'),
          name: '',
          text: 'Free shipping to France. 2nd item and up, huge savings! Log in for details.'
        },
        'IT': {
          icon: require('@/assets/state/IT.png'),
          name: '',
          text: 'Free shipping to Italy. 2nd item and up, huge savings! Log in for details.'
        },
        '1Q': {
          icon: require('@/assets/state/1Q.png'),
          name: '',
          text: 'Free shipping to Zone1. 2nd item and up, huge savings! Log in for details.'
        },
        '2Q': {
          icon: require('@/assets/state/2Q.png'),
          name: '',
          text: 'Free shipping to Zone2. 2nd item and up, huge savings! Log in for details.'
        },
        '3Q': {
          icon: require('@/assets/state/3Q.png'),
          name: '',
          text: 'Free shipping to Zone3. 2nd item and up, huge savings! Log in for details.'
        },
        '4Q': {
          icon: require('@/assets/state/4Q.png'),
          name: '',
          text: 'Free shipping to Zone4. 2nd item and up, huge savings! Log in for details.'
        }
      },
    }
  },
  computed: {
    getBorderStyle () {
      return function (level, index, list) {
        if (index === list.length - 1) {
          if (level === 0) {
            return 'borderBottom: 2px solid #CD8D57'
          } else if (level === 1) {
            return 'borderBottom: 2px solid #CACACA'
          } else if (level === 2) {
            return 'borderBottom: 2px solid #442CB6'
          }
        }
        return ''
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    if (this.$route.path.indexOf('/products') > -1) {
      this.searchType = 1
      this.productName = this.$route.params.name || undefined
    } else {
      this.searchType = 0
      this.productId = this.$route.params.id || undefined
    }
    this.token = this.$route.query.token || undefined
    this.merchantId = this.$route.query.merchantId || undefined
    // this.vipLevel = this.$route.query.vipLevel || 0
    try {
      this.collectIds = JSON.parse(localStorage.getItem('collectIds') || '[]') || []
    } catch (e) {
      this.collectIds = []
    }
    this.getProductLocation()
    this.getAdBanner()
  },
  methods: {
    uuid,
    formatIsoTariff (tariffFee) {
      if (tariffFee == null) {
        return '$0'
      }
      return `$${tariffFee}`
    },
    formatIsoCountry (item, withSpace = true) {
      return withSpace ? `${item.nameEn} (${item.abridge})` : `${item.nameEn}(${item.abridge})`
    },
    getEuCountryCodes () {
      if (this.euCountryCodes) {
        return Promise.resolve(this.euCountryCodes)
      }
      return get('/index/product/euTaxReform/countries').then(res => {
        this.euCountryCodes = res.data || []
        return this.euCountryCodes
      })
    },
    fetchDivisionCountries (logisticType, divisionId) {
      const productId = this.productId || this.skuDesInfo.id
      if (!productId || divisionId == null) {
        return Promise.resolve([])
      }
      return get('/index/product/logistic/division/countries', {
        productId,
        logisticType,
        divisionId
      }).then(res => {
        if (res.code === 200 && res.data) {
          return res.data.isoboList || []
        }
        return []
      })
    },
    showZoneCountriesModal (record) {
      this.zoneCountriesVisible = true
      this.zoneCountriesLoading = true
      this.euZoneCountries = ''
      this.nonEuZoneCountries = ''
      this.euZoneTariff = '$0'
      this.nonEuZoneTariff = '$0'
      const checkedLogistic = this.logisticsList.find(item => item.checked)
      const logisticType = checkedLogistic ? checkedLogistic.key : 'STANDARD SHIPPING'
      Promise.all([
        this.fetchDivisionCountries(logisticType, record.divisionId),
        this.getEuCountryCodes()
      ]).then(([isoboList, euCodes]) => {
        const euCountries = []
        const nonEuCountries = []
        isoboList.forEach(item => {
          if (euCodes.includes(item.abridge)) {
            euCountries.push(item)
          } else {
            nonEuCountries.push(item)
          }
        })
        this.euZoneCountries = euCountries.map(item => this.formatIsoCountry(item)).join(', ')
        this.nonEuZoneCountries = nonEuCountries.map(item => this.formatIsoCountry(item, false)).join(', ')
        if (euCountries.length > 0) {
          this.euZoneTariff = this.formatIsoTariff(euCountries[0].tariffFee)
        }
        if (nonEuCountries.length > 0) {
          this.nonEuZoneTariff = this.formatIsoTariff(nonEuCountries[0].tariffFee)
        }
      }).catch(error => {
        console.error(error)
      }).finally(() => {
        this.zoneCountriesLoading = false
      })
    },
    updateSkuList () {
      const array = []
      const specNames = []
      const specNameOptions = {}
      this.skuDesInfo.specOptionsVOS.forEach(vo => {
        if (vo.type === 0) {
          let optionNames = vo.colorOptionVOList.map(item => item.optionName)
          array.push({name: vo.specsName, data: optionNames, type: 0})
          specNames.push(vo.specsName)
          specNameOptions[vo.specsName] = optionNames
        } else {
          array.push({name: vo.specsName, data: vo.optionNames, type: 1})
          specNames.push(vo.specsName)
          specNameOptions[vo.specsName] = vo.optionNames
        }
      })
      const skuSpecOptions = getCartesianProduct(array)
      const optionNames = new Map()
      skuSpecOptions.forEach(spec => {
        let optionNameStr = ''
        specNames.forEach(specName => {
          optionNameStr += spec[specName]
        })
        optionNames.set(optionNameStr, false)
      })
      // 只保留有真实货号/价格的 SKU，不补无定价的规格组合占位行
      const skuList = []
      this.skuDesInfo.skuViewVOS.forEach((sku, skuIdx) => {
        const newSpecOptions = []
        const options = []

        // 已存在规格-规格值保留、不存规格在删除
        sku.specOptionVOS.forEach(option => {
          if (specNameOptions.hasOwnProperty(option.specsName) && specNameOptions[option.specsName].indexOf(option.optionName) > -1) {
            newSpecOptions[specNames.indexOf(option.specsName)] = option
            options[specNames.indexOf(option.specsName)] = option.optionName
          }
        })

        // 不存在规格补充（不允许重复）
        specNames.forEach((specName, idx) => {
          if (!newSpecOptions.hasOwnProperty(idx)) {
            specNameOptions[specName].forEach(optionName => {
              options[idx] = optionName
              if (optionNames.has(options.join('')) && !optionNames.get(options.join(''))) {
                if (array[idx].type === 0) {
                  newSpecOptions[idx] = {specsName: specName, optionName: optionName, type: 0}
                } else {
                  newSpecOptions[idx] = {specsName: specName, optionName: optionName, type: 1}
                }
              }
            })
          }
        })
        // 不允许重复设置
        if (!optionNames.get(options.join(''))) {
          sku.specOptionVOS = newSpecOptions
          skuList.push(sku)
          optionNames.set(options.join(''), true)
        }
      })
      this.skuDesInfo.skuVOList = skuList
    },
    getProductLocation () {
      get('/index/product/produceLocation')
        .then(response => {
          this.locationList = response.data
        }).finally(error => {
        this.getProductDes()
      })
    },
    getProductDes () {
      function fetchDetails (res) {
        if (res.code === 200) {
          this.skuDesInfo = res.data
          this.skuDesInfo.desc = '<style type="text/css">table {border-collapse: collapse;}</style>' + this.skuDesInfo.desc
          // this.menuItems = this.skuDesInfo.skuViewVOS && this.skuDesInfo.skuViewVOS[0].productCodeLogisticCharge['STANDARD SHIPPING']
          this.menuItems = this.skuDesInfo.allowChargingRulesISODivisionVOS && this.skuDesInfo.allowChargingRulesISODivisionVOS
          this.resultObject = this.getProduceLocation() || {}
          // if (this.resultObject.showName === 'United States') {
          //   this.menuItems = this.menuItems.filter(item => item.divisionValue === 'US')
          // }
          this.initSelection()
          let zoneNames = []
          let removedZone = []
          this.skuDesInfo.skuViewVOS.forEach(item => {
            item['specOptionVOS'] = item.colorOptionVOS ? item.colorOptionVOS.concat(item.specOptionVOS) : item.specOptionVOS
            item.vipPrice.unshift({
              level: this.vipLevel,
              price: item.price
            })
            item.vipPrice.splice(1, 0, {})
            item.vipPrice.splice(3, 0, {})

            item.productCodeLogisticCharge['STANDARD SHIPPING'].forEach(zoneType => {
              zoneNames.indexOf(zoneType.divisionName) >= 0 || zoneNames.push(zoneType.divisionName)
              if (zoneType.price === null || zoneType.price !== 0) {
                removedZone.indexOf(zoneType.divisionName) >= 0 || removedZone.push(zoneType.divisionName)
              }
            })
          })
          let freeZones = zoneNames.filter((x) => removedZone.indexOf(x) === -1)
          if (freeZones && freeZones.length > 0) {
            this.skuDesInfo.priceDescription = 'Free shipping to ' + freeZones.join(' and ') + (freeZones.length > 1 ? ' countries' : '')
          }

          this.skuDesInfo.specColorOptionVOS.forEach(obj => {
            obj.type = 0
          })
          this.skuDesInfo.specOptionsVOS.forEach(obj => {
            obj.type = 1
          })
          this.skuDesInfo.specOptionsVOS = this.skuDesInfo.specColorOptionVOS.concat(this.skuDesInfo.specOptionsVOS)
          this.selectDepartment(this.skuDesInfo.skuViewVOS, this.skuDesInfo.id)
          let list = []
          if (this.skuDesInfo.productImg) {
            list.push(this.skuDesInfo.productImg)
          }
          if (this.skuDesInfo.productTemplateImg) {
            list.unshift(this.skuDesInfo.productTemplateImg)
          }
          this.skuDesInfo.atlas = list.concat(this.skuDesInfo.atlas).map((img, i) => ({
            img,
            selected: false,
            index: i
          }))

          if (res.data.designSpecId) {
            this.getGuidelinesDes(res.data.designSpecId)
          }
          this.getCategoryList()
          this.updateSkuList()
          this.buildLogisticsList()
          const checkedLogistic = this.logisticsList.find(item => item.checked)
          this.getLogisticCharge(checkedLogistic ? checkedLogistic.key : 'STANDARD SHIPPING')
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.carousel.goTo(0, true)
              this.setThumbScroll(0)
            }, 100)
          })
        } else {
          this.$message.error(res.data.msg)
        }
        this.productId = res.data.id
        this.getRecommendList()
      }

      if (this.searchType === 0) {
        get(`/index/product/detail/byId/${this.productId}`, {
          token: this.token,
          merchantId: this.merchantId
        }).then(res => {
          fetchDetails.call(this, res)
        }).catch(error => {
          console.error(error)
        })
      } else {
        get(`/index/product/detail/byName/${this.productName}`, {
          token: this.token,
          merchantId: this.merchantId
        }).then(res => {
          fetchDetails.call(this, res)
        }).catch(error => {
          console.error(error)
        })
      }
    },
    getBaseLogisticKey (key) {
      const baseKeys = ['STANDARD SHIPPING(FAST)', 'STANDARD SHIPPING', 'FAST SHIPPING']
      for (const baseKey of baseKeys) {
        if (key === baseKey || key.startsWith(baseKey)) {
          return baseKey
        }
      }
      return key
    },
    getLogisticDisplayName (key) {
      const nameMap = {
        'STANDARD SHIPPING': 'Standard Shipping',
        'FAST SHIPPING': 'Express Shipping',
        'STANDARD SHIPPING(FAST)': 'Standard Shipping(FAST)',
      }
      if (nameMap[key]) {
        return nameMap[key]
      }
      const baseKey = this.getBaseLogisticKey(key)
      if (nameMap[baseKey] && key.indexOf(baseKey) === 0) {
        return nameMap[baseKey] + key.slice(baseKey.length)
      }
      return key
    },
    getShippingTime (key, showName, hasValidPrice) {
      if (!hasValidPrice) {
        return 'N/A'
      }
      const baseKey = this.getBaseLogisticKey(key)
      if (showName === 'United States') {
        return baseKey === 'STANDARD SHIPPING' ? '4~7 days' : 'N/A'
      }
      if (showName === 'France' || showName === 'Germany') {
        return baseKey === 'STANDARD SHIPPING' ? '3~5 days' : 'N/A'
      }
      if (baseKey === 'STANDARD SHIPPING') {
        return '7~12 days'
      }
      if (baseKey === 'FAST SHIPPING') {
        return '3~7 days'
      }
      if (baseKey === 'STANDARD SHIPPING(FAST)') {
        return '6~10 days'
      }
      return ''
    },
    buildLogisticsList () {
      const baseOrder = ['STANDARD SHIPPING', 'FAST SHIPPING', 'STANDARD SHIPPING(FAST)']
      const chargeMap = this.skuDesInfo.skuViewVOS[0].productCodeLogisticCharge
      const chargeKeys = Object.keys(chargeMap)
      const baseKeys = baseOrder.filter(key => chargeKeys.includes(key))
      const extendedKeys = chargeKeys.filter(key => baseOrder.indexOf(key) === -1)
      extendedKeys.sort((a, b) => {
        const baseA = this.getBaseLogisticKey(a)
        const baseB = this.getBaseLogisticKey(b)
        const orderA = baseOrder.indexOf(baseA)
        const orderB = baseOrder.indexOf(baseB)
        if (orderA !== orderB) {
          return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB)
        }
        return a.localeCompare(b)
      })
      const sortedKeys = baseKeys.concat(extendedKeys)
      const checkedItem = this.logisticsList.find(item => item.checked)
      const checkedKey = checkedItem ? checkedItem.key : null
      this.logisticsList = sortedKeys.map((key, index) => ({
        checked: checkedKey ? key === checkedKey : index === 0,
        key,
        name: this.getLogisticDisplayName(key),
        skuVOList: [],
      }))
    },
    getProduceLocation () {
      const locationId = this.skuDesInfo && this.skuDesInfo.location
      if (!locationId || !this.locationList.length) {
        return this.resultObject && Object.keys(this.resultObject).length ? this.resultObject : null
      }
      return this.locationList.find(item => item.id == locationId) || null
    },
    getLogisticCharge (key) {
      const collectChargeAmounts = (charge, baseKey, vipKeys) => {
        const base = charge[baseKey]
        if (base === null || base < 0) {
          return null
        }
        const vipValues = vipKeys
          .map(k => charge[k])
          .filter(v => v !== null && v !== undefined)
          .map(Number)
        // T1~T3 全部有值时，基础价不参与比较
        if (vipValues.length === vipKeys.length) {
          return vipValues
        }
        return [Number(base), ...vipValues]
      }
      const formatAmountRange = (values) => {
        const min = Math.min(...values)
        const max = Math.max(...values)
        return min === max ? min : `$${min}~${max}`
      }
      const priceVipKeys = ['t1Price', 't2Price', 't3Price']
      const extraPriceVipKeys = ['t1ExtraPrice', 't2ExtraPrice', 't3ExtraPrice']

      if (this.skuDesInfo.skuViewVOS[0].productCodeLogisticCharge.hasOwnProperty(key)) {
        const resultObject = this.getProduceLocation()
        let list = JSON.parse(JSON.stringify(this.skuDesInfo.skuViewVOS[0].productCodeLogisticCharge[key]))
        this.stateList = list
        const showName = resultObject && resultObject.showName
        this.stateList.forEach((item, index) => {
          item['sn'] = 'ALL'
          const hasValidPrice = item.price !== null && item.price >= 0
          item['shippingTime'] = this.getShippingTime(key, showName, hasValidPrice)
          item['children'] = []
          item['key'] = `state_${index}`
          item.price = (item.price === null || item.price < 0) ? 'N/A' : item.price
          item.extraPrice = (item.extraPrice === null || item.extraPrice < 0) ? 'N/A' : item.extraPrice
          item.tariffPrice = 'N/A'
          item.optFee = 'N/A'
          item.totalCostMin = Infinity
          item.totalCostMax = -Infinity
          item.baseCostMin = Infinity
          item.baseCostMax = -Infinity
          const regionPriceValues = []
          const regionExtraPriceValues = []

          // 优化后的主循环逻辑
          this.skuDesInfo.skuViewVOS.forEach((onItem, i) => {
            const charges = onItem.productCodeLogisticCharge[key]
            const charge = charges[index]
            const isUS = charge.divisionValue === 'US'
            let minPrice = onItem.vipPrice.find(item => item.level === 2).price
            let maxPrice = onItem.price
            if (onItem.divisionDiscountVipPrice) {
              const baseFees = onItem.divisionDiscountVipPrice[item.divisionValue]
              minPrice = Math.min(baseFees[0], baseFees[1], baseFees[2])
              maxPrice = Math.max(baseFees[0], baseFees[1], baseFees[2])
            }

            // 2. 提前计算VIP价格和物流价格（避免在getCostPrice中重复查找）
            const priceAmounts = collectChargeAmounts(charge, 'price', priceVipKeys)
            const extraPriceAmounts = collectChargeAmounts(charge, 'extraPrice', extraPriceVipKeys)
            const hasInvalidDivisionPrice = priceAmounts === null

            // 3. 计算费用（关税取自大区 minTariffFee/maxTariffFee，OptFee 仅 US）
            const minTariffFee = charge.minTariffFee != null ? charge.minTariffFee : 0
            const maxTariffFee = charge.maxTariffFee != null ? charge.maxTariffFee : 0
            const hasTariff = charge.minTariffFee != null && charge.maxTariffFee != null
            const optFee = isUS ? (onItem.usOptFee[key] || 0) : 0

            // 4. 构建childItem对象（优化计算逻辑）
            const childItem = {
              price: priceAmounts ? formatAmountRange(priceAmounts) : 'N/A',
              extraPrice: extraPriceAmounts ? formatAmountRange(extraPriceAmounts) : 'N/A',
              priceMin: priceAmounts ? Math.min(...priceAmounts) : null,
              priceMax: priceAmounts ? Math.max(...priceAmounts) : null,
              sn: onItem.sn,
              key: `child_${index}_${i}`,
              tariffPriceMin: hasTariff ? minTariffFee : null,
              tariffPriceMax: hasTariff ? maxTariffFee : null,
              tariffPrice: hasTariff
                ? (minTariffFee === maxTariffFee ? minTariffFee : `$${minTariffFee}~${maxTariffFee}`)
                : 'N/A',
              optFee: isUS ? optFee : 'N/A',
              // 5. 直接计算价格（分区费小于0表示不支持配送，不计入总价）
              baseCostMin: isUS ? (minPrice + optFee).toFixed(2) : minPrice.toFixed(2),
              baseCostMax: isUS ? (maxPrice + optFee).toFixed(2) : maxPrice.toFixed(2),
              totalCostMin: 'N/A',
              totalCostMax: 'N/A',
            }
            if (!hasInvalidDivisionPrice) {
              const minShip = Math.min(...priceAmounts)
              const maxShip = Math.max(...priceAmounts)
              childItem.totalCostMin = (minPrice + optFee + (hasTariff ? minTariffFee : 0) + minShip).toFixed(2)
              childItem.totalCostMax = (maxPrice + optFee + (hasTariff ? maxTariffFee : 0) + maxShip).toFixed(2)
              regionPriceValues.push(...priceAmounts)
            }
            if (extraPriceAmounts) {
              regionExtraPriceValues.push(...extraPriceAmounts)
            }

            // 6. 更新父项价格范围
            if (hasInvalidDivisionPrice) {
              item.totalCostMin = 'N/A'
              item.totalCostMax = 'N/A'
            } else if (item.totalCostMin !== 'N/A') {
              item.totalCostMin = Math.min(item.totalCostMin, childItem.totalCostMin).toFixed(2)
              item.totalCostMax = Math.max(item.totalCostMax, childItem.totalCostMax).toFixed(2)
            }
            item.baseCostMin = Math.min(item.baseCostMin, childItem.baseCostMin).toFixed(2)
            item.baseCostMax = Math.max(item.baseCostMax, childItem.baseCostMax).toFixed(2)

            item.children.push({...childItem})
          })

          if (regionPriceValues.length > 0) {
            item.price = formatAmountRange(regionPriceValues)
          }

          if (regionExtraPriceValues.length > 0) {
            item.extraPrice = formatAmountRange(regionExtraPriceValues)
          }

          const tariffMins = item.children.filter(item => item.tariffPriceMin !== null).map(item => Number(item.tariffPriceMin))
          const tariffMaxs = item.children.filter(item => item.tariffPriceMax !== null).map(item => Number(item.tariffPriceMax))
          if (tariffMins.length > 0) {
            const minTariffPrice = Math.min(...tariffMins)
            const maxTariffPrice = Math.max(...tariffMaxs)
            item.tariffPrice = minTariffPrice === maxTariffPrice ? minTariffPrice : `$${minTariffPrice}~${maxTariffPrice}`
          }

          const optFee = item.children.filter(item => typeof item.optFee === 'number' && item.optFee !== null && item.optFee >= 0).map(item => Number(item.optFee))
          if (optFee.length > 0) {
            const minOptFee = Math.min(...optFee)
            const maxOptFee = Math.max(...optFee)
            item.optFee = minOptFee === maxOptFee ? minOptFee : `$${minOptFee}~${maxOptFee}`
          }

        })
      } else {
        this.stateList = []
      }

    },
    getGuidelinesDes (designSpecId) {
      get(`/index/product/guidelines/${designSpecId}`)
        .then(res => {
          this.designSpecContent = '<style type="text/css">table {border-collapse: collapse;}</style>' + res.data
        })
        .catch(error => {
          console.error(error)
        })

    },
    getCategoryList () {
      get('/index/product/category')
        .then(response => {
          this.menuData = response.data.children
          this.menuData.forEach(l1 => {
            this.expandedMenu.set(l1.id, [l1])
            this.expandedMenuName.set(l1.id, [getSeoLinkName(l1.name)])
            l1.children.forEach(l2 => {
              if (l1.children.length === 1) {
                this.expandedMenu.set(l2.id, [l1])
              } else {
                this.expandedMenu.set(l2.id, [l1, l2])
              }
              if (l2.parentId !== null) {
                this.expandedMenuName.set(l2.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name)])
              }
              l2.children.forEach(l3 => {
                if (l2.children.length === 1) {
                  this.expandedMenu.set(l3.id, [l1, l2])
                } else {
                  this.expandedMenu.set(l3.id, [l1, l2, l3])
                }
                this.expandedMenuName.set(l3.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name), getSeoLinkName(l3.name)])
              })
            })
          })
          const categoryList = (this.skuDesInfo && this.skuDesInfo.categoryList) || []
          const lastCategory = categoryList.length > 0 ? categoryList[categoryList.length - 1] : {}
          const categoryId = lastCategory.id
          this.selectNames = this.expandedMenu.get(categoryId) ? this.expandedMenu.get(categoryId) : []
          this.selectNames.unshift({'name': 'Products', 'id': undefined})
        })
        .catch(error => {
          console.error(error)
        })

    },
    getAdBanner () {
      get(`/index/product/adbanner`)
        .then(res => {
          if (res.code === 200) {
            this.images = res.data ? res.data.split('|') : []
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })

    },
    getRecommendList () {
      get(`/index/product/recommend`, {productId: this.productId})
        .then(res => {
          let dataList = res.data
          dataList.forEach(item => {
            if (!item.productTemplateImg) {
              item['productTemplateImg'] = item.productImg
            }
            const {specColorOptionVOS, specOptionsVOS} = item
            const spec = specColorOptionVOS.map(({
              colorOptionVOList,
              specsName
            }) => `${colorOptionVOList.length} ${specsName}`).join(' ')
            const spec1 = specOptionsVOS.map(({
              optionNames,
              specsName
            }) => `${optionNames.length} ${specsName}`).join(' ')
            item.spec = `${spec} ${' '.repeat(3)} ${spec1}`
          })
          const rightDisplay = dataList.reduce((acc, item, index) => {
            const groupIndex = Math.floor(index / 5)
            if (!acc[groupIndex]) {
              acc[groupIndex] = {imgs: []}
            }
            acc[groupIndex].imgs.push({
              productImg: item.productImg,
              id: item.id,
              productTemplateImg: item.productTemplateImg,
              productNameEn: item.productNameEn,
              minPrice: item.minPrice,
              spec: item.spec,
              seoCustomerAddress: item.seoCustomerAddress,
              performanceTime: item.performanceTime,
              performanceTimeEnd: item.performanceTimeEnd,
            })
            return acc
          }, [])
          rightDisplay.reverse()
          this.recommendList = rightDisplay
        })
        .catch(error => {
          console.error(error)
        })

    },

    hideArrows () {
      const prevArrow = document.getElementById('prevArrow')
      const nextArrow = document.getElementById('nextArrow')
      prevArrow.style.opacity = '1'
      nextArrow.style.opacity = '1'
    },
    showArrows () {
      const prevArrow = document.getElementById('prevArrow')
      const nextArrow = document.getElementById('nextArrow')
      prevArrow.style.opacity = '0'
      nextArrow.style.opacity = '0'
    },
    //接口初始化、选择产品
    selectDepartment (item, selectedVid) {
      this.selectArr = []
      const attrList = setDataToSpecs(item)

      const differenceList = setDifferenceArray(this.skuDesInfo.skuViewVOS)
      differenceList.forEach(item => {
        this.$set(this.shopItemInfo, item.difference, item)
      })
      attrList.forEach(attr => {
        attr.item.forEach(item => {
          this.$set(item, 'checked', true)
        })
      })
      this.specifications = [...attrList]
      this.initSelectedById(differenceList, selectedVid)
    },
    /**
     * 根据默认id初始化选中状态
     * @param list
     * @param selectedId
     */
    initSelectedById (list, selectedId) {
      const selectedItem = list[0]
      if (selectedItem) {
        this.defaultBoxArr = {id: selectedItem.id, difference: selectedItem.difference}
        const selectedAttributes = selectedItem.difference.split(',')
        selectedAttributes.forEach((attr, index) => {
          const attrItem = this.specifications[index].item.find(item => item.name === attr)
          if (attrItem) {
            attrItem.checked = true
            this.selectArrayBtn(attrItem, index, this.specifications[index].item.indexOf(attrItem))
          }
        })
      }
    },
    selectArrayBtn (item, index, arrayIndex) {
      this.$forceUpdate()
      if (index !== 0 && !item.checked) {
        return
      }
      if (this.selectArr[index] === item.name) {
        return
      }
      this.$set(this.selectArr, index, item.name)
      this.$set(this.subIndex, index, arrayIndex)
      this.checkItem()
      this.fixIllegalSelections(index)
      this.syncSelectedSkuPrice()
    },
    fixIllegalSelections (changedIndex) {
      const specs = this.specifications
      for (let i = changedIndex + 1; i < specs.length; i++) {
        const selectedName = this.selectArr[i]
        const items = specs[i].item || []
        const selectedItem = items.find(opt => opt.name === selectedName)
        const isIllegal = !selectedName || !selectedItem || !selectedItem.checked
        if (!isIllegal) {
          continue
        }
        const firstAvailable = items.find(opt => opt.checked)
        if (!firstAvailable) {
          this.$set(this.selectArr, i, '')
          this.$set(this.subIndex, i, -1)
          this.checkItem()
          continue
        }
        const availableIndex = items.indexOf(firstAvailable)
        this.$set(this.selectArr, i, firstAvailable.name)
        this.$set(this.subIndex, i, availableIndex)
        this.checkItem()
      }
    },
    syncSelectedSkuPrice () {
      const selectObj = this.shopItemInfo[this.selectArr.join(',')]
      if (selectObj) {
        this.boxArr = {id: selectObj.id, difference: selectObj.difference}
      } else {
        this.boxArr = {}
      }

      if (!isIdEmpty(this.boxArr)) {
        this.updateVipPriceInfo(this.skuDesInfo, this.boxArr, this.currentCountry, this.matchObj)
      } else if (!isIdEmpty(this.defaultBoxArr)) {
        this.updateVipPriceInfo(this.skuDesInfo, this.defaultBoxArr, this.currentCountry, this.matchObj)
      }
    },
    getMinTariffFee (priceObj, divisionValue) {
      if (!priceObj || !priceObj.productCodeLogisticCharge) {
        return 0
      }
      const charges = priceObj.productCodeLogisticCharge['STANDARD SHIPPING']
      if (!charges) {
        return 0
      }
      const charge = charges.find(item => item.divisionValue === divisionValue)
      if (!charge || charge.minTariffFee == null) {
        return 0
      }
      return Number(charge.minTariffFee)
    },
    updateVipPriceInfo (skuDesInfo, boxArr, currentCountry, matchObj) {
      const priceObj = skuDesInfo.skuViewVOS.find(item => item.id === boxArr.id)
      if (!priceObj) return
      matchObj.vipPrice = priceObj.vipPrice
      const minTariffFee = this.getMinTariffFee(priceObj, currentCountry)
      if (priceObj.divisionVipPrice && priceObj.divisionVipPrice[currentCountry]) {
        matchObj.divisionVipPrice = Object.entries(priceObj.divisionVipPrice[currentCountry])
          .map(([level, price]) => ({
            level: parseInt(level),
            price: price != null && price !== ''
              ? Number((Number(price) + minTariffFee).toFixed(2))
              : price
          }))
      } else {
        matchObj.divisionVipPrice = []
      }
    },
    checkItem () {
      const array = this.specifications
      for (let i = 0; i < array.length; i++) {
        // 第一级始终全部可选；其余级只受上级已选影响，不受下级影响
        if (i === 0) {
          array[i].item.forEach(opt => {
            opt.checked = true
          })
          continue
        }
        const upperResult = []
        for (let j = 0; j < i; j++) {
          upperResult[j] = this.selectArr[j] ? this.selectArr[j] : ''
        }
        array[i].item.forEach(opt => {
          const result = upperResult.slice()
          result[i] = opt.name
          // 下级维度置空，不参与约束
          for (let j = i + 1; j < array.length; j++) {
            result[j] = ''
          }
          opt.checked = this.isMay(result)
        })
      }
      this.specifications = array
    },
    isMay (result) {
      const keys = Object.keys(this.shopItemInfo)
      return keys.some(key => {
        const parts = key.split(',')
        return result.every((val, idx) => !val || parts[idx] === val)
      })
    },
    selectImage (row, index) {
      this.skuDesInfo.atlas.forEach(item => {
        if (row.img === item.img) {
          item.selected = true
        } else {
          item.selected = false
        }
      })
    },
    handleSelectRecommend (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
    isShowTag (item, name) {
      const hasIsName = (item.tagList && item.tagList.some(item => item.showName && item.showName.toLowerCase() === name.toLowerCase())) || false
      return hasIsName
    },
    getImgUrl (i) {
      let url = this.skuDesInfo.atlas[i].img
      return this.$options.filters['imgFilter'](url)
    },
    goToSlidePrev () {
      this.setThumbScroll(Math.min(this.scrollPosition + 97, 0))
    },
    goToSlideNext () {
      const atlasLength = (this.skuDesInfo.atlas && this.skuDesInfo.atlas.length) || 0
      const maxScroll = -Math.max(0, atlasLength - 5) * 97
      this.setThumbScroll(Math.max(this.scrollPosition - 97, maxScroll))
    },
    onCarouselBeforeChange (from, to) {
      this.updateThumbScroll(to)
    },
    setThumbScroll (position) {
      this.scrollPosition = position
      this.applyThumbScrollTransform()
    },
    applyThumbScrollTransform () {
      const carouselEl = this.$refs.carousel && this.$refs.carousel.$el
      if (!carouselEl) {
        return
      }
      const thumbEl = carouselEl.querySelector('.slick-dots.slick-thumb')
      if (!thumbEl) {
        return
      }
      const items = thumbEl.querySelectorAll('li')
      items.forEach(item => {
        item.style.transition = 'transform 0.15s ease'
        item.style.transform = `translate3d(${this.scrollPosition}px, 0px, 0px)`
      })
    },
    updateThumbScroll (currentIndex) {
      const atlas = this.skuDesInfo.atlas || []
      if (!atlas.length) {
        return
      }
      const step = 97
      const visibleCount = 5
      const maxStart = Math.max(0, atlas.length - visibleCount)
      const currentStart = Math.min(maxStart, Math.max(0, Math.round(-this.scrollPosition / step)))
      let start = currentStart
      if (currentIndex < start) {
        start = currentIndex
      } else if (currentIndex >= start + visibleCount) {
        start = currentIndex - visibleCount + 1
      }
      start = Math.min(start, maxStart)
      this.setThumbScroll(-start * step)
    },
    toNewOrder () {
      window.open(process.env.VUE_APP_MERCHANT + 'order/orderlist?productId=' + this.productId, '_blank')
    },
    toContactSupport () {
      window.open('msteams://teams.microsoft.com/l/chat/0/0?users=luojiao@printbelle.com', '_blank')
    },
    toCreateTemplate () {
      if (this.skuDesInfo.hasDesignTemplate) {
        window.open(process.env.VUE_APP_MERCHANT + 'product/designer?templateId=&productId=' + this.productId, '_blank')
      }
    },
    tableChange (row, i) {
      this.logisticsList.forEach(item => {
        if (row.key === item.key) {
          item.checked = true
          this.getLogisticCharge(row.key)
        } else {
          item.checked = false
        }

      })

    },
    callback (key) {
      console.log(key)
    },
    handleMenuClick (item) {

    },
    getCountryIcon (countryCode) {
      const country = this.countryData[countryCode]
      return (country && country.icon) ? country.icon : this.defaultCountryIcon
    },
    selectCountry (country) {
      this.currentCountry = country
      localStorage.setItem('selectedCountry', country)
      if (!this.countryData[this.currentCountry]) {
        this.$set(this.countryData, country, {icon: this.defaultCountryIcon, name: '', text: ''})
      }
      this.updateCountryName()
      const priceBox = !isIdEmpty(this.boxArr) ? this.boxArr : this.defaultBoxArr
      this.updateVipPriceInfo(this.skuDesInfo, priceBox, this.currentCountry, this.matchObj)
    },
    initSelection () {
      const savedCountry = localStorage.getItem('selectedCountry')
      this.currentCountry = this.getValidCountry(savedCountry)
      this.ensureCountryDataExists(this.currentCountry)
      this.updateCountryName()
    },
    getValidCountry (savedCountry) {
      const isValidCountry = savedCountry && this.countryData[savedCountry] && this.menuItems.some(item => item.divisionValue === savedCountry)
      return isValidCountry ? savedCountry : this.getDefaultCountry()
    },
    getDefaultCountry () {
      const first = this.menuItems[0]
      const val = first && first.divisionValue ? first.divisionValue : ''
      return this.resultObject && this.resultObject.showName === 'United States' ? 'US' : val
    },
    ensureCountryDataExists (countryCode) {
      if (!this.countryData[countryCode]) {
        this.$set(this.countryData, countryCode, {icon: this.defaultCountryIcon, name: '', text: ''})
      }
    },
    updateCountryName () {
      const country = this.currentCountry
      const menuItem = this.menuItems.find(item => item.divisionValue === country)
      if (menuItem && this.countryData[country]) {
        this.$set(this.countryData[country], 'name', menuItem.divisionName)
      }
    },
    toProducts (id) {
      if (id) {
        let names = this.expandedMenuName.get(id)
        let urlParams = names.join('/')
        window.location.href = `/products/category/${urlParams}`
      } else {
        window.location.href = `/products`
      }
    },
    onClick (img) {
      if (img.includes('ad_usa')) {
        window.location.href = `/products/category/all-products?tab=other&value=us`
      }
    },
    handleVideo (url) {
      window.open(url, '_blank')
    },
    adjustIframeSize () {
      const iframe = this.$refs.myIframe
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
      if (iframeDocument) {
        const body = iframeDocument.body
        const html = iframeDocument.documentElement

        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
        const width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth)

        iframe.style.height = `${height}px`
        iframe.style.width = `${width}px`
      }
    },
    collect (id) {
      this.collectIds = this.collectIds || []
      const isCollect = this.collectIds.includes(id)
      if (isCollect) {
        this.collectIds = this.collectIds.filter(item => item !== id)
      } else {
        this.collectIds.push(id)
      }
      localStorage.setItem('collectIds', JSON.stringify(this.collectIds))
    },
  },
}
</script>
<style lang="less">

.ant-tabs-nav .ant-tabs-tab {
  padding: 8px 0 8px 2px;
  margin: 0 60px 2px 0;

}

.ant-tabs-ink-bar {
  background-color: #C5FAFF;
  height: 3px;
  margin-top: 2px;
}

.ant-table-row-expand-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 15px;
}

.content-details {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  //margin-top: 72px;

  .ad_banner {
    width: 100%;
    max-width: 1280px;
    height: 120px;
    cursor: pointer;
    background: #FFFFFF;
    margin: 0 auto;
    overflow: hidden;

    .ant-carousel .custom-arrow {
      width: 25px;
      height: 25px;
      font-size: 25px;
      opacity: 0;
      transition: all ease 0.6s;
      color: rgba(31, 45, 61);
    }

    .ant-carousel .custom-arrow:before {
      display: none;
    }

    .ant-carousel:hover .custom-arrow {
      opacity: 1;
    }

    .ant-carousel .slick-dots li {
      background-color: rgba(255, 255, 255, .7);
      border-radius: 20px;
    }

    .ant-carousel .slick-dots li button {
      height: 4px;
      border-radius: 20px;
      background-color: #FFFFFF;
    }
  }

  .carousel-image {
    width: 100%;
    height: 120px;
    object-fit: cover;
    object-position: center;
  }

  .content_info {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 720px;
    margin: 0 auto;
    max-width: 1280px;

    a {
      color: #111111;
    }

    a:hover {
      color: #012169 !important;
    }

    .label {
      display: flex;
      flex-direction: row;
      font-weight: 400;
      font-size: 16px;
      margin-top: 20px;
      margin-bottom: 10px;
      color: #111111;
    }

    .last-item {
      color: #888A96;
    }

    .banner_box {
      display: flex;
      margin-top: 25px;

      .swiper_box {
        width: 570px;
        height: 570px;
        display: flex;
        position: relative;
        -webkit-user-select: none;

        .ant-carousel {
          height: 570px;
          width: 570px;

          .slick-dots {
            width: 500px;
            height: 88px;

            overflow: hidden;
          }


          .slick-slide {
            text-align: center;
            height: 570px;
            line-height: 570px;
            overflow: hidden;

            .img_box:hover .product-operate {
              opacity: 1;
              transition: all ease 0.6s;
            }

            .img_box {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 570px;
              width: 570px;
              position: relative;

              img {
                height: 570px;
                width: 570px;
              }

              .product-operate {
                position: absolute;
                right: 18px;
                top: 18px;
                opacity: 0;
                cursor: pointer;
                display: flex;
                flex-direction: column;


                .collection {
                  width: 48px;
                  height: 48px;
                  background-image: url(../assets/collect-icon.png);
                  background-size: 100% 100%;
                }

                .collected {
                  background-image: url(../assets/collected-icon.png);
                }
              }
            }
          }

          .slick-thumb::-webkit-scrollbar {
            width: 0;
            height: 0;
          }

          .slick-thumb {
            width: 480px;
            margin-left: 45px;
            height: 88px;
            display: flex !important;
            flex-direction: row;
            flex-wrap: nowrap;
            left: 0;
            gap: 5px;
            bottom: -108px;

            .slick-active {
              img {
                filter: grayscale(0%);
                width: 88px;
                height: 88px;
                border-radius: 5px;
                border: 1px solid #012169;
              }
            }

            li {
              display: flex;
              flex-direction: row;
              flex-shrink: 0;
              width: 88px;
              height: 88px;
              will-change: transform;

              img {
                width: 88px;
                height: 88px;
                border: 1px solid transparent;
              }


            }
          }

          .slick_arrow {
            z-index: 1;
            transition: all ease 0.6s;
            color: #504c8f;
          }

          .slick-next::before {
            content: '' !important;
          }

          .slick-prev::before {
            content: '' !important;
          }
        }


        .dots_prev_button {
          width: 37px;
          height: 37px;
          line-height: 37px;
          z-index: 100;
          text-align: center;
          cursor: pointer;
          border-radius: 5px;
          border: 1px solid #D2D2D2;
          background: #FFFFFF;
          color: #8B8B8B;
          bottom: -82px;
          left: 0;
          position: absolute;
          transition: all ease 0.6s;
        }

        .dots_prev_button:hover {
          background: #f5f5f5;
        }

        .dots_next_button {
          width: 37px;
          height: 37px;
          line-height: 37px;
          z-index: 100;
          text-align: center;
          border-radius: 5px;
          border: 1px solid #D2D2D2;
          background: #FFFFFF;
          bottom: -82px;
          right: 0;
          color: #8B8B8B;
          cursor: pointer;
          position: absolute;
          transition: all ease 0.6s;
        }

        .dots_next_button:hover {
          background: #f5f5f5;
        }

        .button-next {
          position: absolute;
          top: 45%;
          opacity: 0;
          right: 5px;
          transition: all ease 0.6s;
        }

        .gallery-top .button-next:hover {
          opacity: 1;
        }

        .button-prev {
          position: absolute;
          top: 45%;
          opacity: 0;
          left: 5px;
          transition: all ease 0.6s;
        }

        .gallery-top .button-prev:hover {
          opacity: 1;
        }

        .gallery-top .swiper-slide img {
          width: 570px;
          height: 570px;
          object-fit: cover;
        }

        .gallery-thumbs {
          width: 570px;
          height: 88px !important;
          display: flex;
          flex-direction: row;

        }

        .gallery-thumbs .swiper-wrapper {
          margin-top: -250.714px;
        }

        .gallery-thumbs .swiper-slide {
          width: 88px;
          height: 88px;
          cursor: pointer;
          border: 2px solid #eaeaea;
          align-self: flex-start;
        }

        .gallery-thumbs .swiper-slide img {
          width: 88px;
          height: 88px;
          object-fit: cover;
        }

        .gallery-thumbs .swiper-slide-active {
          opacity: 1;
          border: 2px solid #012169;
        }
      }

      .banner_info {
        margin-left: 48px;

        .title {
          font-weight: bold;
          font-size: 32px;
          margin-top: 20px;
          color: #111111;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin-bottom: 13px;
        }

        .deliver_box {
          display: flex;
          align-items: center;
          margin-bottom: 19px;
          font-size: 16px;
          width: 100%;

          .text {
            font-weight: 400;
            color: #111111;
            margin-right: 10px;
            white-space: nowrap;
          }

          .country-icon {
            width: 19px;
            height: 19px;
            margin-bottom: 2px;
            margin-right: 10px;
            object-fit: contain;
          }

        }

        .price_view {
          width: 661px;
          padding: 12px 0 12px 29px;
          background: #F7F7F7;
          border-radius: 10px;
        }

        .price {
          font-weight: 500;
          font-size: 18px;
          color: #555555;
        }

        .price_box {
          display: flex;
          padding-left: 3px;

          .item {
            flex: 1;
            display: flex;
            flex-direction: column;

            .item_price {
              font-weight: bold;
              font-size: 28px;
              color: #111111;
              line-height: 32px;
            }

            .item_rank {
              font-weight: 400;
              font-size: 16px;
              color: #111111;
              margin-left: 1px;
              line-height: 16px;
              margin-top: 10px;
            }

            .item_time {
              font-weight: bold;
              font-size: 16px;
              color: #111111;
              display: inline-flex;
              align-items: center;

              .info-icon-days {
                margin-bottom: 0;
                margin-left: 4px;
              }
            }

            .item_day {
              font-weight: bold;
              font-size: 28px;
              margin-top: 5px;
              color: #111111;

              .item_day-days {
                display: inline-flex;
                align-items: center;
                vertical-align: baseline;
                margin-left: 7px;
              }

              .item_day-days-text {
                font-size: 20px;
                color: #888A96;
              }
            }

          }
        }

        .spec_box {
          display: flex;
          margin-top: 20px;
          flex-direction: column;


          .subhead {
            font-weight: bold;
            font-size: 16px;
            color: #111111;
            line-height: 50px;
          }

          .spec_list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 5px;

            .spec_item {
              min-width: 60px;
              padding: 0 8px;
              height: 39px;
              border-radius: 4px;
              cursor: pointer;
              background: #FFFFFF;
              border: 1px solid #E3E4E5;
              margin-right: 15px;
              margin-bottom: 10px;
              font-weight: bold;
              font-size: 16px;
              color: #111111;
              line-height: 38px;
              text-align: center;
            }

            .noneActive {
              background: #ccc;
              border: 1px solid #ccc;
              opacity: 0.4;
              color: #111111;
              cursor: not-allowed;
            }

            .active {
              border-radius: 4px;
              border: 1px solid #E3E4E5;
              box-shadow: inset 0 0 0 1.5px #012169,
              0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              background: #F8FAFC;
            }

            .spec_item_img {
              width: 72px;
              height: 72px;
              background: #FFFFFF;
              border-radius: 6px;
              border: 1px solid #E5E5E5;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              margin-right: 12px;
              margin-bottom: 10px;

              .spec_item_img_inner {
                width: 64px;
                height: 64px;
                background: #F7F7F7;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  width: 55px;
                  height: 50px;
                  object-fit: contain;
                }
              }
            }

            .activeImg {
              border: 2px solid #012169;
            }

            .noneActiveImg {
              opacity: 0.4;
              cursor: not-allowed;
            }

            .spec_item_color {
              width: 42px;
              height: 42px;
              background: #FFFFFF;
              border-radius: 50%;
              border: 2px solid #E3E3E3;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              margin-right: 12px;
              margin-bottom: 10px;

              .spec_item_color_inner {
                width: 32px;
                height: 32px;
                border-radius: 50%;
              }
            }

            .activeColor {
              border: 2px solid #012169;
            }

            .noneActiveColor {
              opacity: 0.4;
              cursor: not-allowed;
            }
          }
        }

        .paused_notice {
          display: flex;
          align-items: flex-start;
          margin-top: 10px;
          margin-bottom: 34px;
          padding: 10px 12px;
          background: #FFF9E6;
          border: 1px solid #FFE0B2;
          border-radius: 5px;

          .paused_notice_icon {
            width: 20px;
            height: 18px;
            margin-right: 10px;
            flex-shrink: 0;
          }

          .paused_notice_text {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #222222;
          }

          .paused_notice_label {
            font-weight: bold;
            font-size: 14px;
            color: #E41734;
          }

          .paused_notice_highlight {
            font-weight: bold;
          }
        }

        .paused_notice + .btn_box {
          margin-top: 16px;
        }

        .btn_box {
          display: flex;
          margin-top: 33px;

          .btn {
            width: 322px;
            height: 46px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D2D2D2;
            text-align: center;
            font-weight: 500;
            font-size: 15px;
            color: #111111;
            cursor: pointer;
            line-height: 46px;
          }

          .btn1 {
            width: 322px;
            height: 46px;
            background: #012169;
            border-radius: 5px;
            border: 1px solid #012169;
            margin-right: 16px;
            text-align: center;
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
            cursor: pointer;
            line-height: 46px;
          }

          .paused {
            background: #E0E2E5;
            border: 1px solid #E0E2E5;
            color: #8C96A3;
            cursor: no-drop;
          }

          .disabled {
            background: #F4F4F4;
            border: 1px solid #D2D2D2;
            color: rgba(0, 0, 0, .25);
            cursor: no-drop;
          }
        }


        .deliver_des {
          font-weight: 400;
          font-size: 16px;
          color: #012169;
          margin-left: 5px;
          margin-top: 12px;
        }
      }
    }
  }

  .tabs_box {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 55px auto;
    max-width: 1280px;

    .ant-tabs-nav {
      font-weight: 400;
      font-size: 16px;
      margin-left: 40px;
      color: #111111;
    }

    .ant-tabs-nav .ant-tabs-tab-active {
      font-weight: bold;
      color: #111111;
    }

    .spec_des_box {
      margin-top: 10px;

      .table_spec {
        width: 100%;
        border-radius: 0px 20px 0px 0px;
        border: 1px solid #D2D2D2;
      }

      .empty_th {
        width: 18px;
        padding: 16px 0;
      }

      .empty_td {
        width: 18px;
        padding: 16px 0;
      }

      .th_price img,
      .th_price1 img,
      .th_price2 img {
        position: static;
        width: 37px;
        height: 34px;
        transform: none;
        margin-right: 8px;
      }

      .vip-level-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }

      .th_price:before {
        width: 225px;
        height: 66px;
        content: "";
        position: absolute;
        top: 0;
        left: -1px;
        border-top: 2px solid #CD8D57;
        border-right: 2px solid #CD8D57;
        border-left: 2px solid #CD8D57;
        border-radius: 20px 20px 0 0;
      }

      .th_price {
        width: 223px;
        height: 66px;
        color: #702E16;
        text-align: center;
        background: linear-gradient(90deg, #F7C388, #FDF3E4, #F7C388);
        border-radius: 20px 20px 0 0;
        position: relative;
        z-index: 2;

      }

      .th_price1:before {
        width: 225px;
        height: 66px;
        content: "";
        position: absolute;
        top: 0;
        left: -1px;
        border-top: 2px solid #CACACA;
        border-right: 2px solid #CACACA;
        border-left: 2px solid #CACACA;
        border-radius: 20px 20px 0 0;
      }

      .th_price1 {
        width: 223px;
        height: 66px;
        color: #535353;
        text-align: center;
        background: linear-gradient(90deg, #BEBEBE, #EEEEEE, #D2D2D2);
        border-radius: 20px 20px 0 0;
        position: relative;
        z-index: 1;
      }

      .th_price2:before {
        width: 225px;
        height: 66px;
        content: "";
        position: absolute;
        top: 0;
        left: -1px;
        border-top: 2px solid #442CB6;
        border-right: 2px solid #442CB6;
        border-left: 2px solid #442CB6;
        border-radius: 20px 20px 0 0;
      }

      .th_price2 {
        width: 223px;
        height: 66px;
        color: #FFFFFF;
        text-align: center;
        background: linear-gradient(90deg, #442CB6, #705AD8, #442CB6);
        border-radius: 20px 20px 0 0;
        position: relative;
        z-index: 2;
      }

      .vip-text {
        font-weight: 500;
        font-size: 18px;

      }

      .td_price {
        border-right: 2px solid #CD8D57;
        border-left: 2px solid #CD8D57;
      }

      .td_price1 {
        border-right: 2px solid #CACACA;
        border-left: 2px solid #CACACA;
      }

      .td_price2 {
        border-right: 2px solid #442CB6;
        border-left: 2px solid #442CB6;
      }

    }

    .logistics_box {
      display: flex;
      flex-direction: column;

      .table_spec {
        width: 100%;
        border-radius: 0;
        border: 1px solid #D2D2D2;
        border-bottom: none;
      }

      .table_box {
        display: flex;
        margin: 15px 0 30px 0;

        .item {
          cursor: pointer;
          padding: 0 20px;
          line-height: 32px;
          text-align: center;
          margin-right: 10px;
          height: 33px;
          background: #F5F5F7;
          border-radius: 15px;
          border: 1px solid #D2D2D2;
          font-weight: 400;
          font-size: 16px;
          color: #111111;
        }

        .active {
          color: #FFFFFF;
          background: #012169;
          border: 1px solid #E3E4E5;
        }
      }
    }
  }

  .item_divider {
    width: 1280px;
    height: 1px;
    background: #E3E4E5;
    margin: 0 auto 58px auto;
  }

  .like_box {
    display: flex;
    width: 1280px;
    margin: 0 auto 30px auto;
    flex-direction: column;

    .title {
      font-weight: bold;
      font-size: 28px;
      color: #111111;
    }

    .ant-carousel .slick-slide {
      width: 239px;
      height: 364px;
      margin-top: 30px;
      overflow: hidden;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;

      .hotBox {
        width: 239px;
        float: left;
        pointer-events: auto;
        margin-left: 8px;
        margin-right: 8px;

        .slide_box:hover {
          background: rgba(227, 227, 227, 0.5);
          transition: all ease 0.3s;
        }

        .slide_box {
          width: 239px;
          height: 364px;
          justify-content: center;
          align-items: center;
          position: relative;

          .img_box {
            width: 239px;
            height: 239px;
            position: relative;
            overflow: hidden;
            transition: all ease 0.3s;


            .img1 {
              width: 100%;
              height: 100%;
              opacity: 1;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }

            .img2 {
              width: 100%;
              height: 100%;
              opacity: 0;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }
          }


          .name {
            width: 223px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 12px 8px 5px 8px;
            font-weight: 500;
            font-size: 18px;
            color: #111111;
          }

          .size {
            width: 223px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 0 8px;
            font-weight: 400;
            font-size: 16px;
            color: #888A96;
            line-height: 21px;
          }

          .price {
            width: 223px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 0 8px;
            line-height: 33px;
            font-weight: 500;
            font-size: 18px;
            color: #111111;
          }

          .tag_box {
            display: flex;
            position: absolute;
            height: 19px;
            top: 10px;
            left: 6px;
            font-family: HarmonyOS Sans SC;
            font-weight: 400;

            .best {
              height: 19px;
              background: #5F2282;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              color: #F0DDFF;
            }

            .new {
              height: 19px;
              background: #FF5C01;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              color: #FDF1D0;
            }

            .trd {
              height: 19px;
              background: #0B550F;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              text-align: center;
              color: #D9FDD6;
            }
          }
        }

        .slide_box:last-child {
          margin-right: 0;
        }


        .slide_box:hover .img_box .img1 {
          opacity: 0;
          transform: scale(1.05);
        }

        .slide_box:hover .img_box .img2 {
          opacity: 1;
          transform: scale(1.05);
        }
      }


    }

    .ant-carousel .custom-slick-arrow {
      width: 40px;
      height: 40px;
      margin: auto;
      position: absolute;
      top: calc((100% - 50px) / 2);
      opacity: 0.5;
      transform: translateY(-50%);
      z-index: 50;
      transition: all ease 0.6s;
    }

    .custom-slick-arrow:before {
      display: none;
    }

    .ant-carousel .custom-slick-arrow:hover {
      opacity: 1;

    }
  }

  .ant-table-thead > tr > th {
    padding: 16px 3px;
    text-align: center;
    font-weight: 500;
    font-size: 17px;
    color: #111111;
    background: #F7F7F7;
  }

  .ant-table-tbody > tr > td {
    text-align: center;
    padding: 16px 3px;
    font-weight: 400;
    font-size: 16px;
    color: #111111;
  }

  .ant-table {
    color: #111111;
  }
}

.country-dropdown {
  min-width: 230px;
  display: flex;
  align-items: center;
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: bold;
  color: #111111;
  cursor: pointer;
  white-space: nowrap;
}

.dropdown-icon {
  font-size: 15px;
  margin-top: 2px;
  transition: transform 0.5s;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
}


.menu-item-selected {
  background: #F0F0F0;
}

.menu-icon {
  width: 19px;
  display: flex;
  align-items: center;
  height: 19px;

  .country-icon {
    width: 19px;
    height: 19px;
    object-fit: contain;
  }
}

.menu-name {
  font-weight: 500;
  font-size: 16px;
  color: #111111;
}

.ant-dropdown-open .dropdown-icon {
  transform: rotate(-180deg);
}

.info-icon {
  margin-bottom: 3px;
  cursor: pointer
}

.zone-countries-modal {
  .ant-modal-body {
    padding: 47px 24px 24px;
  }

  .zone-countries-content {
    min-height: 160px;
  }

  .zone-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .zone-section-header {
    display: flex;
    font-family: HarmonyOS Sans SC;
    align-items: center;
    background: #f5f5f5;
    padding: 10px 16px;
    font-size: 17px;
    line-height: 22px;
    color: #111111;
  }

  .europe-icon {
    width: 28px;
    height: 19px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .zone-section-body {
    padding: 12px 16px;
    font-family: HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 15px;
    color: #111111;
    line-height: 22px;
  }

  .zone-section-body-scroll {
    max-height: 240px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 12px;
    }
  }
}
</style>

<style lang="less">
.spu-tooltip-overlay {
  max-width: 500px;

  .ant-tooltip-inner {
    max-width: 500px;
    padding: 6px 8px 6px 12px;
    box-sizing: border-box;
  }
}

.spu-tooltip-content {
  max-width: 500px;
  max-height: 720px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 8px;
  font-size: 16px;
  line-height: 26px;
  word-break: break-all;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.35);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.55);
  }
}

.spu-tooltip-label {
  margin-bottom: 4px;
  font-weight: bold;
}

.spu-tooltip-item + .spu-tooltip-item {
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/Details.vue